/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import {Button, Checkbox, Form, Input, Select} from "antd";
import styles from './UserListFilters.module.scss';
import {UserListFilterIF} from "../UserList.interface";
import dayjs from "dayjs";

interface UserListFiltersProps {
	filter: UserListFilterIF;
	setFilter: React.Dispatch<React.SetStateAction<UserListFilterIF>>;
	onSearch: () => any;
	onClearFilter: () => any;
}

const UserListFilters = ({ filter, setFilter, onSearch, onClearFilter }: UserListFiltersProps) => {
	return (
		<div className={styles.wrap}>
			<div style={{width: '120px'}}>
				<Input
					placeholder="이름"
					value={filter.name}
					allowClear
					onChange={(e) => {
						setFilter((prev) => ({...prev, name: e.target.value}));
					}}
				/>
			</div>

			<div style={{width: '150px'}}>
				<Input
					placeholder="전화번호"
					value={filter.phoneNum}
					allowClear
					onChange={(e) => {
						setFilter((prev) => ({...prev, phoneNum: e.target.value}));
					}}
				/>
			</div>

			<div style={{width: '200px'}}>
				<Input
					placeholder="이메일"
					value={filter.email}
					allowClear
					onChange={(e) => {
						setFilter((prev) => ({...prev, email: e.target.value}));
					}}
				/>
			</div>

			<div style={{ display: 'flex', alignItems: 'center' }}>
				<Checkbox
					checked={filter.isVerified}
					onChange={(e) => {
						setFilter((prev) => ({...prev, isVerified: e.target.checked }));
					}}
				>
					심사 요청 보기
				</Checkbox>
			</div>

			<div>
				<Button type="primary" onClick={onSearch}>검색</Button>
			</div>

			<div>
				<Button onClick={onClearFilter}>초기화</Button>
			</div>
		</div>
	);
};

export default UserListFilters;
